/**
 * Φραγή ΕΝΕΡΓΟΠΟΙΗΣΗΣ του kiosk ως τη Φάση 5 (απόφαση 16_kiosk_waiter_legacy).
 * Δίδυμο του backend/config/pricingPhase.js — εκεί είναι η πραγματική πύλη.
 *
 * ΓΙΑΤΙ: το SelfCheckoutKiosk χρεώνει base_price + price_modifier χωρίς κανάλι,
 * ενώ το ταμείο χρεώνει την τιμή take away του μεγέθους. Ώσπου το kiosk να
 * διαβάζει τιμή καναλιού (Φ5), ο server απαντά 409 σε κάθε ΜΕΤΑΒΑΣΗ σε true.
 * Εδώ απλώς κλειδώνουμε το checkbox, για να μη βλέπει ο χειριστής ένα κουτί που
 * τσεκάρεται και μετά «σκάει» στην αποθήκευση.
 *
 * Τι ΔΕΝ κλειδώνει: κατάστημα που το έχει ήδη true (staging) — εκεί το κουτί
 * μένει ενεργό ώστε να μπορεί να το ΑΠΕΝΕΡΓΟΠΟΙΗΣΕΙ. Το false περνά πάντα.
 *
 * Στη Φ5 γίνεται false μαζί με τη σημαία του backend.
 */
export const KIOSK_ACTIVATION_LOCKED = true;

// Ίδιος κωδικός με το kioskBlockedBody() του backend.
export const KIOSK_BLOCKED_CODE = 'KIOSK_BLOCKED_PRICE_MIGRATION';

/**
 * Κλειδώνει το checkbox kiosk σε αυτή τη φόρμα;
 *
 * Κρίνει η ΑΡΧΙΚΗ τιμή του καταστήματος, όχι η τρέχουσα του state: αν ο
 * χειριστής ξετσεκάρει ένα ήδη ενεργό kiosk, πρέπει να μπορεί να το ξανατσεκάρει
 * πριν αποθηκεύσει (ο server το δέχεται, γιατί η τιμή στη βάση είναι ακόμη true).
 * Νέο κατάστημα δεν έχει αρχική τιμή → πάντα κλειδωμένο.
 */
export const isKioskToggleLocked = (
  mode: 'create' | 'edit',
  initialKioskEnabled?: boolean | null
): boolean => {
  if (!KIOSK_ACTIVATION_LOCKED) return false;
  if (mode === 'create') return true;
  return initialKioskEnabled !== true;
};

/**
 * Το ελληνικό μήνυμα του 409 της φραγής, αν αυτό είναι το σφάλμα· αλλιώς null
 * (ο καλών δείχνει το δικό του γενικό μήνυμα).
 */
export const kioskBlockedError = (error: any): string | null => {
  const data = error?.response?.data;
  if (error?.response?.status === 409 && data?.code === KIOSK_BLOCKED_CODE) {
    return typeof data.error === 'string' && data.error ? data.error : null;
  }
  return null;
};
